/* eslint-disable no-case-declarations */
import actions from "./actions";

const {
  LIST_ACTIVITIES_BEGIN,
  LIST_ACTIVITIES_SUCCESS,
  LIST_ACTIVITIES_ERR,

  CREATE_ACTIVITY_BEGIN,
  CREATE_ACTIVITY_SUCCESS,
  CREATE_ACTIVITY_ERR,

  UPDATE_ACTIVITY_BEGIN,
  UPDATE_ACTIVITY_SUCCESS,
  UPDATE_ACTIVITY_ERR,

  DELETE_ACTIVITY_BEGIN,
  DELETE_ACTIVITY_SUCCESS,
  DELETE_ACTIVITY_ERR,

  BLOCK_ACTIVITY_BEGIN,
  BLOCK_ACTIVITY_SUCCESS,
  BLOCK_ACTIVITY_ERR,

  UNBLOCK_ACTIVITY_BEGIN,
  UNBLOCK_ACTIVITY_SUCCESS,
  UNBLOCK_ACTIVITY_ERR,

  GET_ACTIVITY_DETAILS_BEGIN,
  GET_ACTIVITY_DETAILS_SUCCESS,
  GET_ACTIVITY_DETAILS_ERR,
} = actions;

const initState = {
  loadingCreateActivity: false,
  errorCreateActivity: "",
  loadingUpdateActivity: false,
  errorUpdateActivity: "",
  activities: [],
  loadingListActivities: false,
  errorListActivities: "",
  totalActivities: 0,
  totalActivitiesPages: 0,
  loadingDeleteActivity: false,
  errorDeleteActivity: "",
  loadingBlockActivity: false,
  errorBlockActivity: null,
  loadingUnblockActivity: false,
  errorUnblockActivity: null,
  loadingGetActivityDetails: false,
  errorGetActivityDetails: null,
  activityDetails: {},
};

const activitiesReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CREATE_ACTIVITY_BEGIN:
      return {
        ...state,
        loadingCreateActivity: true,
        errorCreateActivity: "",
      };
    case CREATE_ACTIVITY_SUCCESS:
      return {
        ...state,
        activities: [...state.activities, data],
        loadingCreateActivity: false,
        errorCreateActivity: "",
      };
    case CREATE_ACTIVITY_ERR:
      return {
        ...state,
        errorCreateActivity: err,
        loadingCreateActivity: false,
      };

    case LIST_ACTIVITIES_BEGIN:
      return {
        ...state,
        loadingListActivities: true,
        errorListActivities: false,
        totalActivities: 0,
        totalActivitiesPages: 0,
      };
    case LIST_ACTIVITIES_SUCCESS:
      return {
        ...state,
        activities: [...data.results],
        loadingListActivities: false,
        errorListActivities: null,
        totalActivities: data.total_count,
        totalActivitiesPages: data.total_pages,
      };
    case LIST_ACTIVITIES_ERR:
      return {
        ...state,
        errorListActivities: err,
        loadingListActivities: false,
        totalActivities: 0,
        totalActivitiesPages: 0,
      };

    case UPDATE_ACTIVITY_BEGIN:
      return {
        ...state,
        loadingUpdateActivity: true,
        errorUpdateActivity: false,
      };
    case UPDATE_ACTIVITY_SUCCESS:
      const updatedActivities = state.activities.map((activity) =>
        activity.id === data.id ? { ...activity, ...data } : activity
      );
      return {
        ...state,
        activities: updatedActivities,
        loadingUpdateActivity: false,
        errorUpdateActivity: null,
      };
    case UPDATE_ACTIVITY_ERR:
      return {
        ...state,
        errorUpdateActivity: err,
        loadingUpdateActivity: false,
      };

    case DELETE_ACTIVITY_BEGIN:
      return {
        ...state,
        loadingDeleteActivity: true,
        errorDeleteActivity: null,
      };
    case DELETE_ACTIVITY_SUCCESS:
      return {
        ...state,
        activities: state.activities.filter(
          (activity) => activity.id !== data.id
        ),
        loadingDeleteActivity: false,
        errorDeleteActivity: null,
      };
    case DELETE_ACTIVITY_ERR:
      return {
        ...state,
        errorDeleteActivity: err,
        loadingDeleteActivity: false,
      };

    case BLOCK_ACTIVITY_BEGIN:
      return {
        ...state,
        loadingBlockActivity: true,
        errorBlockActivity: null,
      };
    case BLOCK_ACTIVITY_SUCCESS:
      return {
        ...state,
        loadingBlockActivity: false,
        errorBlockActivity: null,
      };
    case BLOCK_ACTIVITY_ERR:
      return {
        ...state,
        errorBlockActivity: err,
        loadingBlockActivity: false,
      };

    case UNBLOCK_ACTIVITY_BEGIN:
      return {
        ...state,
        loadingUnblockActivity: true,
        errorUnblockActivity: null,
      };
    case UNBLOCK_ACTIVITY_SUCCESS:
      return {
        ...state,
        loadingUnblockActivity: false,
        errorUnblockActivity: null,
      };
    case UNBLOCK_ACTIVITY_ERR:
      return {
        ...state,
        loadingUnblockActivity: false,
        errorUnblockActivity: err,
      };

    case GET_ACTIVITY_DETAILS_BEGIN:
      return {
        ...state,
        activityDetails: {},
        loadingGetActivityDetails: true,
        errorGetActivityDetails: null,
      };
    case GET_ACTIVITY_DETAILS_SUCCESS:
      return {
        ...state,
        activityDetails: data,
        loadingGetActivityDetails: false,
        errorGetActivityDetails: null,
      };
    case GET_ACTIVITY_DETAILS_ERR:
      return {
        ...state,
        activityDetails: {},
        loadingGetActivityDetails: false,
        errorGetActivityDetails: err,
      };

    default:
      return state;
  }
};

export { activitiesReducer };
